import React, { useEffect, useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

//Components
import Layout from "../../../../Layout/Layout";
import { InputField } from "../../../../Components/formElements/InputField";

import ItemServiceV2 from "../../../../services/customer_v2_appCommonService";
import ItemService from "../../../../services/customer_appCommonService";
import { useSelector } from "react-redux";
import { TextAreaField } from "../../../../Components/formElements/TextAreaField";
import CustomerConstants from "../../../../common/CustomerConstants";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { ComboboxField } from "../../../../Components/formElements/ComboboxField";
import { hasAccess } from "../../../../utils/roleUtils";
import { getTodaysData } from "../../../../common/Validations";

const CashRequestUpdate = () => {
  localStorage.setItem("menu", "Finance");
  localStorage.setItem("submenu", "Cash Request");
  let cashId = useSelector(
    (state) => state?.customer?.cashRequest?.cashRequestNr
  );
  const [userRole, setUserRole] = useState(null);
  const [isCardVisible1, setCardVisible1] = useState(true);
  const [isCardVisible2, setCardVisible2] = useState(true);
  const [getDropdownData, setDropdownData] = useState("");
  const [getCashRequestUpdate, setCashRequestUpdate] = useState();
  const [disabled, setDisabled] = useState(false);
  let userData = useSelector((state) => state?.user?.data); // User Details from Store
  let pageConfig = useSelector((state) => state?.common?.data?.pageConfig); // Config Details from Store
  const [pageConfigInfo, setPageConfigInfo] = useState(null);
  const [getCompanyCode, setCompanyCode] = useState([]);
  const navigate = useNavigate();
  const [editMode, setEditMode] = useState(true);
  const [getcashRequestDetail, setCashRequestDetail] = useState([]);

  // eslint-disable-next-line
  const adminConfirmationData = [
    { id: 2, name: "Partial Amount" }, //yellow
    { id: 3, name: "Full Amount" }, //green
  ];

  const toggleCardVisibility1 = () => {
    setCardVisible1(!isCardVisible1);
  };
  const toggleCardVisibility2 = () => {
    setCardVisible2(!isCardVisible2);
  };

  ///Edit and cancle

  const cashRequestUpdates = () => {
    setEditMode(false);
  };
  const cancelUpdate = () => {
    setEditMode(true);
  };

  const [cashRequest, setCashRequest] = useState({
    cashRequestNr: "",
    cashRequestStatus: "",
    salesOfficerCode: "",
    salesOfficerName: "",
    customerCode: "",
    customerName: "",
    paymentPurpose: "",
    paymentMode: "",
    cashAmount: "",
    cashAmountInWords: "",
    receivedBy: "",
    receiverContactNumber: "",
    adminConfirmation: "",
    adminRemarks: "",
    adminReceivedAmount: "",
    adminReceivedDate: getTodaysData() || "",
    customerBankName: "",
    partyCode: "CE",
  });

  //Validations
  const [validation, setValidation] = useState({
    cashRequestNr: "",
    cashRequestStatus: "",
    cashRequestDate: "",
    salesOfficerCode: "",
    salesOfficerName: "",
    customerCode: "",
    customerName: "",
    paymentPurpose: "",
    paymentMode: "",
    cashAmount: "",
    cashAmountInWords: "",
    receivedBy: "",
    receiverContactNumber: "",
  });

  const remaining =
    cashRequest.cashAmount &&
    cashRequest.adminReceivedAmount &&
    parseFloat(cashRequest.adminReceivedAmount) <
      parseFloat(cashRequest.cashAmount)
      ? parseFloat(cashRequest.cashAmount) -
        parseFloat(cashRequest.adminReceivedAmount)
      : 0;

  const filteredAdminConfirmationData = React.useMemo(() => {
    if (remaining > 0) {
      return adminConfirmationData.filter((item) => item.id !== 3); // hide Full Amount
    } else {
      return adminConfirmationData.filter((item) => item.id !== 2); // hide Partial Amount
    }
  }, [remaining, adminConfirmationData]);

  useEffect(() => {
    if (
      cashRequest.adminConfirmation &&
      !filteredAdminConfirmationData.some(
        (item) => item.name === cashRequest.adminConfirmation
      )
    ) {
      setCashRequest((prev) => ({
        ...prev,
        adminConfirmation: "", // clear invalid value
      }));
    }
  }, [filteredAdminConfirmationData, cashRequest.adminConfirmation]);

  useEffect(() => {
    if (cashRequest.cashAmount && !cashRequest.adminReceivedAmount) {
      setCashRequest((prev) => ({
        ...prev,
        adminReceivedAmount: prev.cashAmount,
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cashRequest.cashAmount]);

  const loadMasterData = async () => {
    let obj1 = {
      codeType: "companyCode",
    };
    await ItemService.getMasterData(obj1).then((item) => {
      // console.log(">> item! title", item);
      if (item?.status === 200) {
        setCompanyCode(item?.data);
      } else {
        setCompanyCode([]);
        console.log(">> Error: Loading Company Code");
      }
    });
  };

  const handleInputChange = ({ target: { name, value } }) => {
    // const { name, value } = event.target;
    const errors = {};
    setCashRequest((prev) => ({ ...prev, [name]: value }));

    // passing logic to input fields
    if (name === "cashAmount") {
      if (!isNaN(value) && value !== "") {
        setCashRequest((prev) => ({
          ...prev,
          cashAmount: value,
          cashAmountInWords: convertNumberToWords(value),
        }));
      } else {
        setCashRequest((prev) => ({
          ...prev,
          cashAmount: "",
          cashAmountInWords: "",
        }));
      }
    }

    if (name === "adminReceivedAmount") {
      const entered = parseFloat(value || 0);
      const actual = parseFloat(cashRequest.cashAmount || 0);

      if (entered > actual) {
        toast.error("Received Amount cannot be greater than Cash Amount!");
        return;
      }

      setCashRequest((prev) => ({
        ...prev,
        [name]: value,
      }));
      return;
    }

    setValidation((prev) => ({
      ...prev,
      [name]: errors[name] || "",
    }));
  };
  useEffect(() => {
    const getRole = userData?.roles?.[0]?.roleId || null;
    setUserRole(getRole);
    setPageConfigInfo(pageConfig);
  }, [pageConfig, userData]);

  const convertNumberToWords = (num) => {
    if (num === "" || isNaN(num)) return "";
    num = parseFloat(num).toFixed(2);
    let [rupees, paise] = num.split(".");
    rupees = parseInt(rupees);
    paise = parseInt(paise);

    const ones = [
      "",
      "One",
      "Two",
      "Three",
      "Four",
      "Five",
      "Six",
      "Seven",
      "Eight",
      "Nine",
      "Ten",
      "Eleven",
      "Twelve",
      "Thirteen",
      "Fourteen",
      "Fifteen",
      "Sixteen",
      "Seventeen",
      "Eighteen",
      "Nineteen",
    ];

    const tens = [
      "",
      "",
      "Twenty",
      "Thirty",
      "Forty",
      "Fifty",
      "Sixty",
      "Seventy",
      "Eighty",
      "Ninety",
    ];

    const scales = ["", "Thousand", "Million", "Billion", "Trillion"];

    const convertBelowThousand = (n) => {
      if (n < 20) return ones[n];
      if (n < 100)
        return (
          tens[Math.floor(n / 10)] + (n % 10 !== 0 ? " " + ones[n % 10] : "")
        );
      return (
        ones[Math.floor(n / 100)] +
        " Hundred" +
        (n % 100 !== 0 ? " " + convertBelowThousand(n % 100) : "")
      );
    };

    let words = "";
    let scaleIndex = 0;

    while (rupees > 0) {
      let part = rupees % 1000;
      if (part !== 0) {
        words =
          convertBelowThousand(part) +
          " " +
          scales[scaleIndex] +
          (words ? " " + words : "");
      }
      rupees = Math.floor(rupees / 1000);
      scaleIndex++;
    }

    words = words.trim() ? words.trim() + " Rupees" : "";

    if (paise > 0) {
      let paiseWords = convertBelowThousand(paise) + " Paise";
      words += " and " + paiseWords;
    }

    return words || "Zero Rupees";
  };

  useEffect(() => {
    if (getcashRequestDetail.length > 0) {
      setCashRequest((prev) => ({
        ...prev,
        ...getcashRequestDetail[0],
      }));
    }
  }, [getcashRequestDetail]);

  //Drop Down

  useEffect(() => {
    if (!getDropdownData) return;
    setCashRequest((prev) => ({
      ...prev,
      [getDropdownData?.textField]: getDropdownData?.name,
      [getDropdownData?.textCode]: getDropdownData?.textCode,
      [getDropdownData?.textDesc]: getDropdownData?.textDesc,
    }));
    if (getDropdownData?.textField === "adminConfirmation") {
      setCashRequest((prev) => ({
        ...prev,
        adminConfirmation: getDropdownData?.name,
      }));
    }
  }, [getDropdownData]);

  //Get cash request API
  useEffect(() => {
    cashRequestUpdate();
    loadMasterData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const cashRequestUpdate = async () => {
    let obj = {
      documentNumber: cashId,
    };
    await ItemServiceV2.getCashRequestDetail(obj).then((item) => {
      // console.log('>> Check title ',item);
      if (item?.status === 200) {
        // console.log(">>PO data", item?.data);
        setCashRequestDetail(item?.data);
      } else {
        setCashRequestDetail([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
  };

  useEffect(() => {
    if (cashRequest) {
      setCashRequestUpdate({
        adminRemarks: cashRequest?.adminRemarks,
        adminReceivedDate: cashRequest?.adminReceivedDate,
        cashRequestStatus: cashRequest?.adminConfirmation,
        adminReceivedAmount: cashRequest?.adminReceivedAmount,
        cashRequestNr: cashRequest?.cashRequestNr,
        salesOfficerCode: cashRequest?.salesOfficerCode,
        salesOfficerName: cashRequest?.salesOfficerName,
        customerCode: cashRequest?.customerCode,
        customerName: cashRequest?.customerName,
        paymentPurpose: cashRequest?.paymentPurpose,
        paymentMode: cashRequest?.paymentMode,
        cashAmountInWords: cashRequest?.cashAmountInWords,
        receivedBy: cashRequest?.receivedBy,
        receiverContactNumber: cashRequest?.receiverContactNumber,
        adminConfirmation: cashRequest?.adminConfirmation,
        companyBank: cashRequest?.companyBank,
        companyCode: cashRequest?.companyCode,
        companyCodeDesc: cashRequest?.companyCodeDesc,
        partyCode: cashRequest?.partyCode,
      });
    }
  }, [cashRequest]);

  //backup code dont remove
  // const handleUpdate = async () => {
  //   try {
  //     setDisabled(true);
  //     const obj = { ...getCashRequestUpdate }; // your update object
  //     const amount = parseFloat(obj.adminReceivedAmount || 0);

  //     const debitPayload = {
  //       data: {
  //         companyCode: "", // empty
  //         cashType: "CR",
  //         companyCodeDesc: obj.companyCodeDesc,
  //         customerCode: obj.customerCode, // filled
  //         customerCodeDesc: obj.customerName,
  //         transaction: "Payment",
  //         transactionType: "EK",
  //         customerBank: obj.customerBank || "",
  //         companyBank: obj.companyBank || "",
  //         transactionMode: obj.paymentMode,
  //         salesOfficerCode: obj.salesOfficerCode,
  //         salesOfficerName: obj.salesOfficerName,
  //         bankTransactionDate: obj.cashRequestDate,
  //         partyCode: obj.partyCode,
  //         remarks: obj.adminRemarks,
  //         expensesHead: obj.adminRemarks,
  //         cashRequestNr: obj.cashRequestNr,
  //         adminConfirmation: obj.adminConfirmation,
  //         customerName: obj.customerName,
  //         type: "DEBIT",
  //         items: [
  //           {
  //             slNo: "1",
  //             creditAmount: 0,
  //             debitAmount: amount,
  //             transaction: "Payment",
  //           },
  //         ],
  //         documentNumber: obj.documentNumber,
  //         invoiceNr: obj.documentNumber,
  //         invoiceStatusHeader: "Updated",
  //         createdBy: obj.createdBy,
  //         createdByName: obj.createdByName,
  //         updatedAt: new Date().toISOString(),
  //       },
  //     };
  //     const creditPayload = {
  //       data: {
  //         companyCode: obj.companyCode, // filled
  //         companyCodeDesc: obj.companyCodeDesc,
  //         customerCode: "", // empty
  //         customerCodeDesc: obj.companyCodeDesc,
  //         transaction: "Receipt",
  //         transactionType: "EK",
  //         bankName: obj.companyBank,
  //         expensesHead: obj.adminRemarks,
  //         customerBank: obj.customerBank || "",
  //         companyBank: obj.companyBank || "",
  //         transactionMode: obj.paymentMode,
  //         bankTransactionDate: obj.adminReceivedDate,
  //         salesOfficerCode: obj.salesOfficerCode,
  //         salesOfficerName: obj.salesOfficerName,
  //         partyCode: obj.partyCode,
  //         remarks: obj.adminRemarks,
  //         cashRequestNr: obj.cashRequestNr,
  //         adminConfirmation: obj.adminConfirmation,
  //         customerName: obj.customerName,
  //         cashType: "CR",
  //         type: "CREDIT",
  //         items: [
  //           {
  //             slNo: "1",
  //             creditAmount: amount,
  //             debitAmount: 0,
  //             transaction: "Receipt",
  //           },
  //         ],
  //         documentNumber: obj.documentNumber,
  //         invoiceNr: obj.documentNumber,
  //         invoiceStatusHeader: "Updated",
  //         createdBy: obj.createdBy,
  //         createdByName: obj.createdByName,
  //         updatedAt: new Date().toISOString(),
  //       },
  //     };

  //     await ItemServiceV2.updateCashRequest(obj);
  //     await ItemServiceV2.addInvoice(debitPayload);
  //     await ItemServiceV2.addInvoice(creditPayload);
  //     toast.success("Cash request updated successfully!", {
  //       duration: 2000,
  //       position: "top-right",
  //     });
  //     navigate(CustomerConstants.CUSTOMER_V2_CASH_REQUEST_LIST);
  //   } catch (err) {
  //     toast.error("Failed to update cash request!");
  //   } finally {
  //     setDisabled(false);
  //   }
  // };

  const handleUpdate = async () => {
    try {
      setDisabled(true);
      const obj = { ...getCashRequestUpdate }; // your update object
      const amount = parseFloat(obj.adminReceivedAmount || 0);

      // ---------------- DEBIT PAYLOAD (Company debited) ----------------
      const debitPayload = {
        data: {
          companyCode: obj.companyCode, // now company is debited
          companyCodeDesc: obj.companyCodeDesc,
          customerCode: "", // empty
          customerCodeDesc: obj.companyCodeDesc,
          transaction: "Payment",
          transactionType: "EK",
          bankName: obj.companyBank,
          expensesHead: obj.adminRemarks,
          customerBank: obj.customerBank || "",
          companyBank: obj.companyBank || "",
          transactionMode: obj.paymentMode,
          bankTransactionDate: obj.adminReceivedDate,
          salesOfficerCode: obj.salesOfficerCode,
          salesOfficerName: obj.salesOfficerName,
          partyCode: obj.partyCode,
          remarks: obj.adminRemarks,
          cashRequestNr: obj.cashRequestNr,
          adminConfirmation: obj.adminConfirmation,
          customerName: obj.customerName,
          cashType: "CR",
          type: "DEBIT",
          items: [
            {
              slNo: "1",
              creditAmount: 0,
              debitAmount: amount,
              transaction: "Payment",
            },
          ],
          documentNumber: obj.documentNumber,
          invoiceNr: obj.documentNumber,
          invoiceStatusHeader: "Updated",
          createdBy: obj.createdBy,
          createdByName: obj.createdByName,
          updatedAt: new Date().toISOString(),
        },
      };

      // ---------------- CREDIT PAYLOAD (Customer credited) ----------------
      const creditPayload = {
        data: {
          companyCode: "", // empty
          companyCodeDesc: obj.companyCodeDesc,
          customerCode: obj.customerCode, // customer credited
          customerCodeDesc: obj.customerName,
          transaction: "Receipt",
          transactionType: "EK",
          customerBank: obj.customerBank || "",
          companyBank: obj.companyBank || "",
          transactionMode: obj.paymentMode,
          bankTransactionDate: obj.cashRequestDate,
          salesOfficerCode: obj.salesOfficerCode,
          salesOfficerName: obj.salesOfficerName,
          partyCode: obj.partyCode,
          remarks: obj.adminRemarks,
          cashRequestNr: obj.cashRequestNr,
          adminConfirmation: obj.adminConfirmation,
          customerName: obj.customerName,
          cashType: "CR",
          type: "CREDIT",
          items: [
            {
              slNo: "1",
              creditAmount: amount,
              debitAmount: 0,
              transaction: "Receipt",
            },
          ],
          documentNumber: obj.documentNumber,
          invoiceNr: obj.documentNumber,
          invoiceStatusHeader: "Updated",
          createdBy: obj.createdBy,
          createdByName: obj.createdByName,
          updatedAt: new Date().toISOString(),
        },
      };

      // ---------------- API CALLS ----------------
      await ItemServiceV2.updateCashRequest(obj);
      await ItemServiceV2.addInvoice(debitPayload);
      await ItemServiceV2.addInvoice(creditPayload);

      toast.success("Cash request updated successfully!", {
        duration: 2000,
        position: "top-right",
      });
      navigate(CustomerConstants.CUSTOMER_V2_CASH_REQUEST_LIST);
    } catch (err) {
      toast.error("Failed to update cash request!");
    } finally {
      setDisabled(false);
    }
  };

  return (
    <main className="dashboard main" id="main">
      <Layout />

      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={12} md={9} lg={9}>
                <h2 className="mainTitle">
                  Cash Request Details{""}
                  <span className="bg-table-status bg-table-documentNumber-status headerStatusDetailedPage">
                    {cashId}
                  </span>
                  <span>
                    {cashRequest?.cashRequestStatus === "Reject" ? (
                      <span className="bg-table-status bg-table-new-status headerStatusDetailedPage">
                        {cashRequest?.cashRequestStatus}
                      </span>
                    ) : cashRequest?.cashRequestStatus === "Partial Amount" ? (
                      <span className="bg-table-status bg-table-progress-status headerStatusDetailedPage">
                        {cashRequest?.cashRequestStatus}
                      </span>
                    ) : cashRequest?.cashRequestStatus === "Cash in Transit" ? (
                      <span className="bg-table-status bg-table-progress-status headerStatusDetailedPage">
                        {cashRequest?.cashRequestStatus}
                      </span>
                    ) : cashRequest?.cashRequestStatus === "Full Amount" ? (
                      <span className="bg-table-status bg-table-success-status headerStatusDetailedPage">
                        {cashRequest?.cashRequestStatus}
                      </span>
                    ) : cashRequest?.cashRequestStatus === "Not Received" ? (
                      <span className="bg-table-status bg-table-danger-status headerStatusDetailedPage">
                        {cashRequest?.cashRequestStatus}
                      </span>
                    ) : (
                      cashRequest?.cashRequestStatus
                    )}
                  </span>
                </h2>
                <p className="subText"> Cash Request Details </p>
              </Col>
            </Row>
            <hr />
            <Row className="mb-4">
              {/* edit button */}
              {editMode && (
                <Col
                  xs={6}
                  md={{ span: 2, offset: 10 }}
                  lg={{ span: 2, offset: 10 }}
                  className="text-left"
                >
                  {hasAccess(
                    userRole,
                    "buttons",
                    "customer_details_edit",
                    pageConfigInfo
                  ) && (
                    <Col xs={6} md={2} lg={2} className="text-left">
                      <button className="btnInfo" onClick={cashRequestUpdates}>
                        Edit
                      </button>
                    </Col>
                  )}
                </Col>
              )}
              {!editMode && (
                <Col
                  xs={6}
                  md={{ span: 2, offset: 8 }}
                  lg={{ span: 2, offset: 8 }}
                  className="text-left"
                >
                  <button
                    className="btnInfo"
                    onClick={handleUpdate}
                    disabled={disabled}
                  >
                    {disabled ? "Updating..." : "Update"}
                  </button>
                </Col>
              )}
              {!editMode && (
                <Col xs={6} md={2} lg={2} className="text-left">
                  <button className="btnInfo btn-danger" onClick={cancelUpdate}>
                    Cancel
                  </button>
                </Col>
              )}
            </Row>
            {/* 01 */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible1
                            ? "bi-chevron-down"
                            : "bi-chevron-right"
                        }`}
                        onClick={toggleCardVisibility1}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">CD</span>
                    </Col>
                    <Col xs={8} md={9} lg={9}>
                      <span className="headerTitle">Cash Request Details </span>
                      <span className="subHeaderTitle">
                        Cash Request Details
                      </span>
                    </Col>
                  </Row>
                </h2>
                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible1 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4 d-flex align-items-center">
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          type="date"
                          label="Received Date"
                          name="cashRequestDate"
                          id="cashRequestDate"
                          value={cashRequest.cashRequestDate}
                          onChange={handleInputChange}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commLeftRightPadding"
                      >
                        <ComboboxField
                          label="Company Name"
                          placeholder=""
                          data={getCompanyCode}
                          id="companyCode"
                          iconClassName="dropdownIcon"
                          name="companyCode"
                          code="companyCode"
                          description="companyCodeDesc"
                          setValue={cashRequest.companyCode || ""}
                          getvalue={setDropdownData}
                          required={true}
                          error={validation.companyCode}
                          disabled={true}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commLeftRightPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Customer Name"
                          placeholder=""
                          id="customerName"
                          name="customerName"
                          value={cashRequest.customerName || ""}
                          onChange={handleInputChange}
                          required={true}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commLeftRightPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Cash Request Status"
                          placeholder=""
                          name="cashRequestStatus"
                          id="cashRequestStatus"
                          value={cashRequest.cashRequestStatus || ""}
                          onChange={handleInputChange}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Payment Mode"
                          placeholder="Cash"
                          name="defaultCash"
                          id="defaultCash"
                          value={cashRequest.defaultCash || ""}
                          onChange={handleInputChange}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Cash Amount"
                          placeholder="Enter amount"
                          name="cashAmount"
                          id="cashAmount"
                          error={validation.cashAmount || ""}
                          value={cashRequest.cashAmount || ""}
                          onChange={handleInputChange}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <TextAreaField
                          className="inputBox"
                          label="Cash Amount in Words"
                          placeholder="Cash Amount in Words"
                          name="cashAmountInWords"
                          id="cashAmountInWords"
                          value={cashRequest.cashAmountInWords || ""}
                          onChange={handleInputChange}
                          disabled={true}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Received By"
                          name="receivedBy"
                          id="receivedBy"
                          value={cashRequest.receivedBy}
                          error={validation.receivedBy || ""}
                          onChange={handleInputChange}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Receiver Contact"
                          name="receiverContactNumber"
                          id="receiverContactNumber"
                          value={cashRequest.receiverContactNumber || ""}
                          error={validation.receiverContactNumber || ""}
                          onChange={handleInputChange}
                          disabled={true}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <TextAreaField
                          className="inputBox"
                          label="Payment Purpose"
                          name="paymentPurpose"
                          id="paymentPurpose"
                          value={cashRequest.paymentPurpose}
                          error={validation.paymentPurpose || ""}
                          onChange={handleInputChange}
                          disabled={true}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            {/* Admin Confirmation */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible2
                            ? "bi-chevron-down"
                            : "bi-chevron-right"
                        }`}
                        onClick={toggleCardVisibility2}
                      ></i>
                    </Col>

                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">AD</span>
                    </Col>
                    <Col xs={8} md={9} lg={9}>
                      <span className="headerTitle">Admin Details</span>
                      <span className="subHeaderTitle">Admin Details</span>
                    </Col>
                  </Row>
                </h2>
                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible2 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row className="accordion-button">
                      <Col
                        xs={12}
                        md={4}
                        lg={3}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Received Amount"
                          type="number"
                          name="adminReceivedAmount"
                          id="adminReceivedAmount"
                          value={cashRequest.adminReceivedAmount || ""}
                          onChange={(e) => {
                            const enteredValue = parseFloat(
                              e.target.value || 0
                            );
                            const maxAmount = parseFloat(
                              cashRequest.cashAmount || 0
                            );

                            if (enteredValue > maxAmount) {
                              // ✅ Prevent exceeding
                              setCashRequest((prev) => ({
                                ...prev,
                                adminReceivedAmount: maxAmount,
                              }));
                            } else {
                              handleInputChange(e);
                            }
                          }}
                          disabled={editMode}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={3}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Remaining Amount"
                          name="shortReceivedAmount"
                          id="shortReceivedAmount"
                          value={
                            cashRequest.cashAmount &&
                            cashRequest.adminReceivedAmount &&
                            parseFloat(cashRequest.adminReceivedAmount) <
                              parseFloat(cashRequest.cashAmount)
                              ? parseFloat(cashRequest.cashAmount) -
                                parseFloat(cashRequest.adminReceivedAmount)
                              : 0
                          }
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={3}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          type="date"
                          label="Received Date"
                          name="adminReceivedDate"
                          id="adminReceivedDate"
                          value={cashRequest.adminReceivedDate}
                          onChange={handleInputChange}
                          disabled={editMode}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={3}
                        className="commTopButtonRightLeftPadding"
                      >
                        <TextAreaField
                          className="inputBox"
                          label="Remarks"
                          name="adminRemarks"
                          id="adminRemarks"
                          value={cashRequest.adminRemarks || ""}
                          onChange={handleInputChange}
                          disabled={editMode}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={3}
                        lg={3}
                        className="commLeftRightPadding"
                      >
                        <ComboboxField
                          label="Admin Confirmation"
                          placeholder=""
                          data={filteredAdminConfirmationData} // ← filtered options here
                          id="adminConfirmation"
                          iconClassName="dropdownIcon"
                          name="adminConfirmation"
                          code="adminConfirmationCode"
                          description="adminConfirmationDesc"
                          setValue={cashRequest.adminConfirmation}
                          getvalue={setDropdownData}
                          required={true}
                          disabled={editMode}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </main>
  );
};

export default CashRequestUpdate;
